import { writable } from "svelte/store";
export const singleInput = writable("");
export const bulkInput = writable("");
export const findInput = writable("");
